module.exports = __webpack_public_path__ + "img/accesspermissions1.f9b8ca2e.jpg";